"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
/**
 * @hidden
 */
var RATING_ACTION;
(function (RATING_ACTION) {
    RATING_ACTION["select"] = "select";
    RATING_ACTION["deselect"] = "deselect";
    RATING_ACTION["increase"] = "increase";
    RATING_ACTION["decrease"] = "decrease";
    RATING_ACTION["min"] = "min";
    RATING_ACTION["max"] = "max";
    RATING_ACTION["reset"] = "reset";
})(RATING_ACTION = exports.RATING_ACTION || (exports.RATING_ACTION = {}));
/**
 * @hidden
 */
exports.ratingReducer = function (state, action) {
    switch (action.type) {
        case RATING_ACTION.select:
            if (action.payload === undefined || action.step === undefined) {
                return state;
            }
            if (action.payload === state) {
                return null;
            }
            return action.payload >= action.min
                ? action.payload < action.max
                    ? utils_1.toRound(action.payload, action.step)
                    : action.max
                : action.min;
        case RATING_ACTION.deselect:
            return null;
        case RATING_ACTION.increase:
            if (action.step === undefined) {
                return state;
            }
            if (state < action.min) {
                return action.min;
            }
            return state + action.step < action.max
                ? utils_1.toRound(state + action.step, action.step)
                : action.max;
        case RATING_ACTION.decrease:
            if (action.step === undefined) {
                return state;
            }
            return utils_1.toRound(state - action.step, action.step) >= action.min
                ? utils_1.toRound(state - action.step, action.step)
                : action.min;
        case RATING_ACTION.min:
            if (action.step === undefined) {
                return state;
            }
            return action.min;
        case RATING_ACTION.max:
            return action.max;
        case RATING_ACTION.reset:
            return null;
        default:
            return state;
    }
};
//# sourceMappingURL=rating-reducer.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-inputs@3.18.0_@progress+kendo-drawing@1.21.2_@progress+kendo-react-anim_73gurhvqk4avqqnlz5vbps7pya/~/@progress/kendo-react-inputs/dist/npm/rating/rating-reducer.js
// module id = 6600
// module chunks = 0